import React, { Component } from 'react'
import { connect } from 'react-redux'
import { withRouter, NavLink } from 'react-router-dom'
import { ModalContainer } from 'react-router-modal'
import { detectMobile } from '../util'

import { actions } from '../redux/modules/authentication'

const propTypes = {}

class AdminApp extends Component {
  state = {
    sideMenuShowing: true
  }

  onClickSidebarLink = () => {
    if (detectMobile()) {
      this.setState({
        sideMenuShowing: false
      })
    }
  }

  toggleSideMenu() {
    this.setState({
      sideMenuShowing: !this.state.sideMenuShowing
    })
  }

  signOut() {
    this.props.logout()
  }

  render() {
    const { props } = this
    const { user } = this.props
    return (
      <div className="jobs">
        <div className="container-fluid">
          <div className="row">
            <nav
              className={
                this.state.sideMenuShowing
                  ? 'col-md-3 col-lg-2 d-md-block bg-light sidebar showing side-menu-showing'
                  : 'sidebar col-md-2 hiddenStyle side-menu-not-showing'
              }
            >
              <div className="sidebar-sticky">
                <ul className="nav flex-column sidebarUl">
                  <li className="nav-item profile">
                    <div className="profilePicture" />
                    <div className="profileName">
                      {`${props.user.firstName} ${props.user.lastName}`}
                      &nbsp;
                      <i className="fa fa-angle-down" aria-hidden="true" />
                    </div>
                  </li>
                  <div className="separator" />
                  <li className="nav-item">
                    <NavLink
                      className={'nav-link'}
                      to="/dashboard"
                      onClick={this.onClickSidebarLink}
                    >
                      <span data-feather="dashboard" />
                      <i className="fa fa-tachometer" aria-hidden="true" /> Dashboard
                    </NavLink>
                  </li>
                  <li className="nav-item">
                    <NavLink className={'nav-link'} to="/jobs" onClick={this.onClickSidebarLink}>
                      <span data-feather="home" />
                      <i className="fa fa-building-o" aria-hidden="true" /> Jobs
                    </NavLink>
                  </li>
                  <li className="nav-item">
                    <NavLink className={'nav-link'} to="/items" onClick={this.onClickSidebarLink}>
                      <span data-feather="file" />
                      <i className="fa fa-cube" aria-hidden="true" /> Items
                    </NavLink>
                  </li>
                  <li className="nav-item">
                    <NavLink className={'nav-link'} to="/leads" onClick={this.onClickSidebarLink}>
                      <span data-feather="shopping-cart" />
                      <i className="fa fa-address-card" aria-hidden="true" /> Leads
                    </NavLink>
                  </li>
                  <li className="nav-item">
                    <NavLink
                      className={'nav-link'}
                      to="/companies"
                      onClick={this.onClickSidebarLink}
                    >
                      <span data-feather="users" />
                      <i className="fa fa-briefcase" aria-hidden="true" /> Companies
                    </NavLink>
                  </li>
                  <li className="nav-item">
                    <NavLink className={'nav-link'} to="/vendors" onClick={this.onClickSidebarLink}>
                      <span data-feather="bar-chart-2" />
                      <i className="fa fa-users" aria-hidden="true" /> Vendors
                    </NavLink>
                  </li>
                  <li className="nav-item">
                    <NavLink
                      className={'nav-link'}
                      to="/contacts"
                      onClick={this.onClickSidebarLink}
                    >
                      <span data-feather="layers" />
                      <i className="fa fa-address-book" aria-hidden="true" /> Contacts
                    </NavLink>
                  </li>
                  {(user.isAdmin || user.isController1) && (
                    <li className="nav-item">
                      <NavLink
                        className={'nav-link'}
                        to="/employees"
                        onClick={this.onClickSidebarLink}
                      >
                        <span data-feather="layers" />
                        <i className="fa fa-street-view" aria-hidden="true" /> Employees
                      </NavLink>
                    </li>
                  )}
                  <li className="nav-item">
                    <NavLink className={'nav-link'} to="/tasks" onClick={this.onClickSidebarLink}>
                      <span data-feather="layers" />
                      <i className="fa fa-tasks" aria-hidden="true" /> Tasks
                    </NavLink>
                  </li>
                  <li className="nav-item">
                    <NavLink className={'nav-link'} to="/drivers" onClick={this.onClickSidebarLink}>
                      <span data-feather="layers" />
                      <i className="fa fa-id-card" aria-hidden="true" /> Drivers
                    </NavLink>
                  </li>
                  <li className="nav-item">
                    <NavLink
                      className={'nav-link'}
                      to="/vehicles"
                      onClick={this.onClickSidebarLink}
                    >
                      <span data-feather="layers" />
                      <i className="fa fa-truck" aria-hidden="true" /> Vehicles
                    </NavLink>
                  </li>
                  {user.isAdmin && (
                    <li className="nav-item">
                      <NavLink className={'nav-link'} to="/users" onClick={this.onClickSidebarLink}>
                        <span data-feather="layers" />
                        <i className="fa fa-user-circle" aria-hidden="true" /> Users
                      </NavLink>
                    </li>
                  )}
                  <li className="nav-item">
                    <NavLink
                      className={'nav-link'}
                      to="/templates/estimate"
                      onClick={this.onClickSidebarLink}
                    >
                      <span data-feather="layers" />
                      <i className="fa fa-magic" aria-hidden="true" /> Templates &amp; Forms
                    </NavLink>
                  </li>
                  <li className="nav-item">
                    <NavLink className={'nav-link'} to="/reports" onClick={this.onClickSidebarLink}>
                      <span data-feather="layers" />
                      <i className="fa fa-line-chart" aria-hidden="true" /> Reports
                    </NavLink>
                  </li>
                  <li className="nav-item">
                    <NavLink className={'nav-link'} to="/help" onClick={this.onClickSidebarLink}>
                      <span data-feather="layers" />
                      <i className="fa fa-question-circle" aria-hidden="true" /> Help
                    </NavLink>
                  </li>
                  {/*<li className="nav-item">
                    <Link className="nav-link" to="/jobs">
                      <span data-feather="layers" />
                      <i className="fa fa-info-circle" aria-hidden="true" /> Info
                    </Link>
                    </li>*/}
                </ul>

                <div className="separator" />
              </div>
            </nav>

            <main
              role="main"
              className={
                this.state.sideMenuShowing
                  ? 'col-md-9 ml-sm-auto col-lg-10 pt-3 px-4 mainContent'
                  : 'col-md-12 ml-sm-auto col-lg-12 pt-3 px-4 mainContent'
              }
            >
              <nav className="navbar navbar-dark sticky-top bg-dark flex-md-nowrap p-0">
                <div
                  onClick={() => this.toggleSideMenu()}
                  className={
                    this.state.sideMenuShowing
                      ? 'toggleSideMenuButton'
                      : 'toggleSideMenuButton rotateDiv'
                  }
                >
                  <i className="fa fa-bars" aria-hidden="true" />
                </div>
                <input
                  className="form-control form-control-dark w-100 searchControl"
                  type="text"
                  placeholder="&#xf002; Search for a job or lead or a contact..."
                  aria-label="Search"
                />
                <button className="addJobButton">
                  <i className="fa fa-plus" aria-hidden="true" />
                </button>
                <NavLink to="/dashboard">
                  <button className="preferencesButton">
                    <i className="fa fa-th-large" aria-hidden="true" />
                  </button>
                </NavLink>
                <button className="logoutButton" onClick={() => this.signOut()}>
                  <i className="fa fa-sign-out" aria-hidden="true" />
                </button>
              </nav>
              <div className="h-100">{props.children}</div>
            </main>
          </div>
        </div>
        <ModalContainer />
      </div>
    )
  }
}

const mapStateToProps = (state, { location }) => ({
  location,
  user: state.authentication.user
})
const mapDispatchToProps = (dispatch, ownProps) => ({
  logout: () => dispatch(actions.logout())
})

AdminApp.propTypes = propTypes
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(AdminApp))



// WEBPACK FOOTER //
// ./src/containers/AdminApp.js